import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import OrderButton from './OrderButton';

export default function LeftOrderButtons(props) {
  const { sort, item, order, setSorting, isTgitemsContext } = props;

  const value = item.get('value');

  if (sort !== value) {
    return null;
  }

  return (
    <span className="result-toolbar-sort-by-left-order-buttons" role="group" aria-label="Sort order">
      <OrderButton
        icon="ArrowDown"
        item={item}
        order={order}
        setSorting={setSorting}
        buttonOrderValue="desc"
        isTgitemsContext={isTgitemsContext}
      />
      <OrderButton
        icon="ArrowUp"
        item={item}
        order={order}
        setSorting={setSorting}
        buttonOrderValue="asc"
        isTgitemsContext={isTgitemsContext}
      />
    </span>
  );
}

LeftOrderButtons.propTypes = {
  sort: PropTypes.string.isRequired,
  item: PropTypes.instanceOf(Map).isRequired,
  order: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  isTgitemsContext: PropTypes.bool.isRequired,
};
